import * as getter from '../types/getters'
import * as action from '../types/actions'
import linq from 'linq'
import { classValidate } from '../../utility/validateUtility'
import store from '../../store'
import Paginate from '../../models/Paginate'
import { buildQuery } from '../../utility/stringUtility'
import News from '../../models/News'

export const state = {
    newsList: new Paginate().setModel(new News()),
    news: new News(),
}

export const mutations = {
    [action.FETCH_NEWS_LIST](state, paginate) {
        state.newsList = paginate
    },

    [action.FETCH_NEWS](state, news) {
        state.news = news
    },

    [action.CLEAR_NEWS](state) {
        state.news = new News()
    },

    [action.UPDATE_NEWS](state, news) {
        state.news = news
    },
}

export const actions = {
    async [action.FETCH_NEWS_LIST]({ commit, state }) {
        const query = buildQuery(store.state.route.query)
        const { data } = await axios.get(`/api/news-list?${query}`)

        const paginate = state.newsList.create(data)
        commit(action.FETCH_NEWS_LIST, paginate)
    },

    async [action.FETCH_NEWS]({ commit }) {
        const id = `/${store.state.route.params.id}` || null
        const { data } = await axios.get(`/api/news${id}`)

        const news = new News(data)
        commit(action.FETCH_NEWS, news)
    },

    [action.CLEAR_NEWS]({ commit }) {
        commit(action.CLEAR_NEWS)
    },

    [action.UPDATE_NEWS]({ commit }, news) {
        const data = new News(news)
        commit(action.UPDATE_NEWS, data)
    },
}

export const getters = {
    [getter.NEWS_LIST]: (state) => state.newsList,
    [getter.NEWS]: (state) => state.news,
}

export default {
    state,
    mutations,
    actions,
    getters,
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/news.js